import { createFeatureSelector } from '@ngrx/store';

import { State } from './state';

export const selectHeaderState = createFeatureSelector<State>('header');
